import { render, staticRenderFns } from "./CardTags.vue?vue&type=template&id=3abea1b4&"
import script from "./CardTags.vue?vue&type=script&lang=js&"
export * from "./CardTags.vue?vue&type=script&lang=js&"
import style0 from "./CardTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports